import { Channel } from '../../../../models/channel.enum';

export default class SalesChannelPrice {
  public salesChannel: Channel;
  public priceInSek: number;

  constructor(salesChannel: Channel, priceInSek: number) {
    this.salesChannel = salesChannel;
    this.priceInSek = priceInSek;
  }
}
